import * as React from 'react';
import { createViewConfig } from '@sail/engine';
import { Button } from '@sail/ui';
import { HoverArrow } from './HoverArrow';
var ButtonTypeMapping;
(function(ButtonTypeMapping) {
    ButtonTypeMapping["primary"] = "primary";
    ButtonTypeMapping["link"] = "secondary";
    ButtonTypeMapping["secondary"] = "secondary";
})(ButtonTypeMapping || (ButtonTypeMapping = {}));
export const CtaButtonConfig = createViewConfig({
    props: {},
    name: 'CtaButton',
    defaults: {
        type: 'primary',
        href: '',
        size: 'medium',
        arrow: true
    }
});
/**
 * The primary call to action button used across stripe.com.
 */ export const CtaButton = CtaButtonConfig.createView(({ arrow, type, children, ...props })=>{
    return /*#__PURE__*/ React.createElement(Button, {
        ...props,
        type: ButtonTypeMapping[type],
        className: "CtaButton"
    }, children, arrow ? /*#__PURE__*/ React.createElement(HoverArrow, null) : null);
}, {
    css: {
        ':active': {
            keyline: 'none',
            border: 'none'
        }
    },
    forward: {
        type: true,
        arrow: true
    },
    variants: {
        arrow: {
            true: {
                css: {
                    gap: 'xsmall',
                    paddingRight: 'space.150'
                }
            }
        }
    }
});

//# sourceMappingURL=CtaButton.js.map